import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type ReportBookingListItem = ResultOf<
  typeof reportBookingListQuery
>["reportBookings"][number];

export const reportBookingListQuery = graphql(`
  query ReportBookingList(
    $rangeStartDate: String!
    $rangeEndDate: String!
    $supplierId: ID
    $dateBasis: BookingReportDateBasis
  ) {
    reportBookings(
      supplier_id: $supplierId
      range_start_date: $rangeStartDate
      range_end_date: $rangeEndDate
      date_basis: $dateBasis
    ) {
      booking_reference
      booking_name
      booking_email
      booking_phone
      booking_status
      booking_created_at
      booking_confirmed_at
      booking_depart_at
      booking_deliver_at
      booking_supplier_reference
      booking_currency
      booking_customer_cost
      relocation_reference
      relocation_created_at
      days_to_booking
      supplier_name
      vehicle_name
      departure_office_name
      delivery_office_name
      fuel_description
      fuel_value
      other_description
      other_value
      negative_description
      negative_value
      ferry_description
    }
  }
`);
